<template>
    <div>
        <h4>{{ label }}</h4>

        <!-- upload images button -->
        <uploadButton
            v-if="!!showUploadButton"
            :title="buttonLabel"
            class="my-3 white--text"
            color="green"
            :fileChangedCallback="emitUploadImage"
            :uniqueId="true"
            accept=".gif, .svg, image/*"
            :disabled="isDisabled"
            multiple
        >
            <template slot="icon">
                <v-icon class="ml-2" dark>image</v-icon>
            </template>
        </uploadButton>

        <p v-if="!imagePresent && !imageOptional" class="ml-4 error--text">Il faut obligatoirement ajouter une image</p>
        <p v-else-if="!imagePresent" class="ml-4 warning--text">Sans image, une note est obligatoire (section « Notes »)</p>

        <!-- uploaded images -->
        <div
            v-for="(img, index) in images"
            :key="index"
            class="d-inline-block"
        >
            <v-img
                class="mx-auto"
                :src="img.src"
                width="75px"
                style="cursor: pointer;"
                @click="emitPopUpImage(img)"
            />

            <p class="caption text-xs-center">Image {{ index + 1 }}</p>

            <!-- uploaded image delete button -->
            <v-btn
                v-if="!!showDeleteButton"
                class="error"
                small
                @click="emitRemoveImage(img)"
            >
                supprimer
            </v-btn>
        </div>
    </div>
</template>

<script>
    import UploadButton from 'vuetify-upload-button';

    export default {
        name: "ImagesUpload",
        props: ['images', 'isDisabled', 'showUploadButton', 'showDeleteButton', 'label', 'buttonLabel', 'imagesOrigin', 'imageOptional'],
        components: { UploadButton },
        methods: {
            //emits upload image
            //blob URL instead of a base64 data URL: several phone photos as base64 crashed mobile tabs (#40)
            emitUploadImage(files) {
                if(!!files) {
                    const fileList = Array.from(files).map(file => ({
                        src: URL.createObjectURL(file),
                        title: file.name,
                        file: file,
                        toUpload: true,
                    }));

                    this.$emit('uploadImage', fileList);
                }
            },

            //emits pop up image
            emitPopUpImage(img) {
                this.$emit('popUpImage', { img: img, origin: this.imagesOrigin });
            },

            //emits remove image
            emitRemoveImage(img) {
                this.$emit('removeImage', {
                    src: img.src,
                    title: !!img.file ? img.file.name : img.title,
                    origin: this.imagesOrigin,
                });
            },
        },
        computed: {
            imagePresent() {
                return Array.isArray(this.images) && this.images.length > 0;
            }
        }
    }
</script>

<style scoped>

</style>
